export default "__VITE_PUBLIC_ASSET__2a1aaa65__"